import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { TranslatorService } from './../../../../shared/services/utils/translator.service';

@Component({
  selector: 'drag-and-drop-base',
  templateUrl: './drag-and-drop-base.component.html',
  styleUrls: ['./drag-and-drop-base.component.scss']
})
export class DragAndDropBaseComponent implements OnInit, AfterViewInit {

  @ViewChild('search', { static: false }) search: any;
  @Input()
  itemsList = [];

  itemsSelected = [];

  itemsListUpdated = [];

  loadingData: boolean;

  title: string;
  itemsSelectedTitle: string;
  itemsUnselectedTitle: string;

  constructor(protected readonly translatorService: TranslatorService) {
    this.itemsSelectedTitle = this.translatorService.trans(`drag-and-drop.item-selected-title`);
    this.itemsUnselectedTitle = this.translatorService.trans(`drag-and-drop.item-unselected-title`);

    setTimeout(() => {
      this.itemsListUpdated = this.itemsList;
    }, 1000);
  }

  ngOnInit() { }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }

  ngAfterViewInit(): void {
    fromEvent(this.search.nativeElement, 'keydown')
      .pipe(
        debounceTime(350),
        map(x => x['target']['value'])
      )
      .subscribe(value => {
        this.searchElementInList(value);
      });
  }

  searchElementInList(textElement: string) {
    if (!textElement) {
      return this.itemsListUpdated = this.itemsList.filter((itemSelected) => {
        return !this.itemsSelected.includes(itemSelected);
      });
    }

    return this.itemsListUpdated = (this.itemsList || []).filter(item =>
      'name'.split(',').some(key =>
        item.hasOwnProperty(key) && new RegExp(this.escapeRegex(textElement), 'gisy').test(item[key]))).filter((itemSelected) => {
          return !this.itemsSelected.includes(itemSelected);
        });
  }

  private escapeRegex(string) {
    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }
}
